import { Media } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/items.d.ts').WorkListingItem}
 */

const WorkListingItem = ({
    displayTitle,
    listingMedia,
    sectors,
    swatch,
    title,
    url
}) => {
    return (
        <div className='expand-interaction group w-full'>
            {listingMedia?.video &&
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='w-full'
                    poster={listingMedia.video.url}
                    src={listingMedia.video.src} />
            }

            {!listingMedia?.video && listingMedia?.image &&(
                <div className='w-full'>
                    <Media image={{
                        ...listingMedia.image,
                        containerClassName: 'w-full'}}/>
                </div>
            )}

            <div className={`${displayTitle ? '' : 'max-h-0 overflow-hidden transition-all duration-300 ease-in group-hover:max-h-42'}`}>
                <div className='px-16 py-8 flex'>
                    <div
                        className='w-20 h-20'
                        style={{ backgroundColor: swatch}}/>
                    <a
                        className='expand-interaction__action px-8'
                        href={url}>
                        {title}
                        {sectors?.length > 0 && (
                            <>
                                {', '}
                                <span className='underline underline-offset-2'>
                                    {sectors[0].title}
                                </span>
                            </>
                        )}
                    </a>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default WorkListingItem;
